import React, { Component } from 'react';
import { observer } from 'mobx-react';
import axios from 'axios';
import '@availity/yup';
import Icon from '@availity/icon';
import {
	Form,
	Field,
	FormGroup,
	Radio,
	RadioGroup,
	Checkbox,
	CheckboxGroup
} from '@availity/form';
import select, { SelectField } from '@availity/select';
import { DateField } from '@availity/date';
import { Button, Label, Row, Col } from 'reactstrap';
import * as yup from 'yup';
import { Redirect, withRouter } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import CustomProgressBar from '../../Common/components/CustomProgressBar';
import awardeestore from '../stores/awardeestore';


@observer
export default class HousingProfile extends Component {
	constructor(props) {
		super(props);

		this.state = {
			redirectToAdditionalQuestions: false,
			redirectToProviderAwardeePage: false
		}

		if (awardeestore.getAwardeeHousingPageStatus('#housingprofile') !== 'stepwizard-step active') {
			awardeestore.setAwardeeHousingPageStatus('#housingprofile', 'active');
		}

		if(window.performance) {
			if(performance.navigation.type == 1) {
				awardeestore.resetAwardeeHousingPageStatus();
				window.location.href = '#';
			}
		}
	}

	componentDidMount() {
		if (awardeestore.getCountyListCount() === 0) {
			const URL = "/SupportiveHousingAssessment/EN/configupdate/assessment.config";
			axios({
				method: 'get',
				url: URL,
			})
				.then(function (response) {
					awardeestore.setCountyList(response.data["assessment.config"][0].codeValues);
				})
				.catch(function (error) {
					return error;
				});
		}

		window.onpopstate = () => {
			this.props.history.go(1);
		}
	}

	setHousingInfoCounty = value => {
		awardeestore.setHousingInfoCounty(value);
	}
	setHousingInfoUnitSizeRadio = value => {
		awardeestore.setHousingInfoUnitSizeRadio(value);
	}

	setHousingModificationsRadio = (event) => {
		const value = event.target.value;
		awardeestore.setHousingModificationsRadio(value);
		if(value === "No") {
			awardeestore.setReasonableAccommodationsDetails('');
		}
	};
	setReasonableAccommodationsDetails = event => {
		const { value } = event.target;
		awardeestore.setReasonableAccommodationsDetails(value);
	}
	goBack = () => {
		this.setState({ redirectToProviderAwardeePage: true });
	}

	submit = () => {
		awardeestore.completedSteps.housingprofile = true;
		this.setState({ redirectToAdditionalQuestions: true });
	}

	onChangeUseQuestion = (selected) => {
		if(!selected.includes('A wheelchair')) {
			awardeestore.setWheelchairType('');
			awardeestore.setWheelchairWidth('');
		}
		awardeestore.setWalkerAndWheelchair(selected)
	}

	onChangeWheelchairType = (selected) => {
		awardeestore.setWheelchairType(selected)
		awardeestore.setWheelchairWidth('');
	}

	getSelectOptions = (start, end, labelValue) => {
		const selectOptions = [];
		while (start <= end) {
			selectOptions.push({
				value: labelValue(start), label: labelValue(start)
			});
			start += 1;
		}
		return selectOptions;
	}

	onChangeWidthOfWheelchair = (selected) => {
		awardeestore.setWheelchairWidth(selected);
	}

	onChangeOtherPreferences = (event) => {
		awardeestore.setOtherPreferences(event.target.value)
	}

	onChangeOtherHouseHoldPerson = (selected) => {
		awardeestore.setOtherHouseHoldPerson(selected)
	}

	onChangePeopleLiving = (selected) => {
		awardeestore.setPeopleLiving(selected);
		awardeestore.updatepeopleLivingDetails();
	}

	onChangePeopleLivingDetails = (e, fieldName, index) => {
		awardeestore.setPeopleLivingDetails(e.target.value, fieldName, index);
	}

	getPeopleInformation = () => {
		const peopleLivingElements = [];
		const { housingInfo } = awardeestore;
		const { peopleLivingDetails } = housingInfo;
		for (let i = 0; i < peopleLivingDetails.length; i++) {
			const peopleLivingDetail = peopleLivingDetails[i]
			peopleLivingElements.push(
				<FormGroup key={`peopleLivingFormGroupKey-${i}`} className='peopleLivingElements shadow-sm p-2 bg-white rounded' name={`individualLivingDetailsGroup-${i}`}>
					<Row>
						<Col sm='4'>
							{this.getTextField("First Name*", "firstName", peopleLivingDetail, i)}
						</Col>
						<Col sm='4'>
							{this.getTextField("Last Name*", "lastName", peopleLivingDetail, i)}
						</Col>
						<Col sm='2'>
							{this.getTextField("Age*", "age", peopleLivingDetail, i, 3)}
						</Col>
						<Icon
							name='cancel'
							size='small'
							className='pplLivCancel'
							onClick={() => awardeestore.removeSingleLivDetail(i)}
						/>
					</Row>
					<Row>
						<Col sm='4'>
							{this.getTextField("Phone*", "phone", peopleLivingDetail, i, 10)}
						</Col>
						<Col sm='4'>
							{this.getTextField("Relationship*", "relationship", peopleLivingDetail, i)}
						</Col>
					</Row>
				</FormGroup>
			)
		}
		return peopleLivingElements;
	}

	getTextField = (label, fieldName, peopleLivingDetail, index, maxLength = 50) => {
		return (
			<FormGroup name={`${fieldName}FormGroup-${index}`} for={`peopleLivingDetailsForm${fieldName}-${index}`} className='label-font'>
				<Label name={`${fieldName}Label-${index}`} htmlFor={`peopleLivingDetailsForm${fieldName}-${index}`}>
					{label}
				</Label>
				<Field
					type="text"
					id={`peopleLivingDetailsForm${fieldName}-${index}`}
					name={`peopleLivingDetailsForm${fieldName}-${index}`}
					className='straighten-borders'
					onChange={(e) => this.onChangePeopleLivingDetails(e, fieldName, index)}
					value={peopleLivingDetail[fieldName]}
					maxLength={maxLength}
				/>
			</FormGroup>
		)
	}

	getValidationDetailsForLivingPersons = () => {
		const { housingInfo, livingPersonValidation } = awardeestore;
		const { peopleLivingDetails } = housingInfo;
		const validationObj = {}
		peopleLivingDetails.forEach((element, index) => {
			Object.keys(element).forEach((key) => {
				validationObj[`peopleLivingDetailsForm${key}-${index}`] = livingPersonValidation[key];
			})
		});
		return validationObj;
	}



	getIndividualInititalValues = () => {
		const { housingInfo } = awardeestore;
		const { peopleLivingDetails } = housingInfo;
		const validationObj = {}
		peopleLivingDetails.forEach((element, index) => {
			Object.keys(element).forEach((key) => {
				validationObj[`peopleLivingDetailsForm${key}-${index}`] = peopleLivingDetails[index][key]
			})
		});
		return validationObj;
	}

	render() {

		const { userAgent } = navigator;
		const { redirectToProviderAwardeePage, redirectToAdditionalQuestions } = this.state;
		const {
			awardeeHousingPages,
			housingInfo,
			countyRegions,
			countyList
		} = awardeestore;

		const { location } = this.props;

		const fromReviewAndSubmitPage = location && location.state && location.state.fromReviewAndSubmitPage;

		const { peopleLivingDetails } = housingInfo;

		const individualInitialValues = this.getIndividualInititalValues();
		const individualValidation = this.getValidationDetailsForLivingPersons()

		if (redirectToProviderAwardeePage) {
			return <Redirect to='/providerinfo' />
		}

		if (redirectToAdditionalQuestions) {
			return <Redirect to={fromReviewAndSubmitPage ? "/reviewAndSubmit" : "/additionalQuestions"} />
		}

		return (
			<>
				<div className='border-form'>
					<CustomProgressBar pages={awardeeHousingPages} />

					<small className='required-fields'>*required</small>
					<div className='spacer-48' />
					<h2 className='poppinsH2'>
						Housing Profile
					</h2>
					<div className='spacer-28' />
					<Form
						enableReinitialize
						initialValues={{
							housingInfoCounty: housingInfo.county,
							housingInfoRegion: housingInfo.region,
							housingInfoUnitSizeRadio: housingInfo.unitSize,
							housingModificationsRadio: housingInfo.modifications,
							reasonableAccommodationsDetails: housingInfo.reasonableAccommodations,
							walkerandwheelchair: housingInfo.walkerAndWheelChair.map(x => x),
							wheelchairTypeRadio: housingInfo.wheelchairType,
							widthOfWheelchair: housingInfo.wheelchairWidth,
							otherPreferences: housingInfo.otherPreferences,
							otherHouseHoldPersonRadio: housingInfo.otherHouseHoldPerson,
							peopleLiving: housingInfo.peopleLiving,
							...individualInitialValues
						}}
						onSubmit={this.submit}
						validationSchema={yup.object().shape({
							housingInfoCounty: yup
								.string()
								.required('County is required'),
							housingInfoRegion:
								housingInfo.county === 'Other' ?
									yup
										.string()
										.required('Region is required')
									:
									yup
										.string(),
							housingInfoUnitSizeRadio: yup
								.string()
								.required('Unit Size is required'),
							housingModificationsRadio: yup
								.string()
								.required('Required'),
							wheelchairTypeRadio: housingInfo.walkerAndWheelChair && housingInfo.walkerAndWheelChair.includes('A wheelchair') ? yup.string().required('Please select Manual / Electric!') : null,
							widthOfWheelchair: housingInfo.wheelchairType ? yup.string().required('Please enter width of the chair'): null,
							otherHouseHoldPersonRadio: yup.string().required('Please select Yes / No!'),
							peopleLiving: yup.number().required(),
							...(housingInfo.modifications === 'Yes' ? {reasonableAccommodationsDetails: yup.string().required('Please enter a value before continuing!')} : {}),
							...individualValidation
						})}
					>
						<Row>
							<Col sm='4'>
								<FormGroup for="housingInfoCounty" className="label-font">
									<h6 className='label-font'>
										<b>In which county would you like to live?*</b>
									</h6>
									<SelectField
										name="housingInfoCounty"
										label="Select County*"
										className="straighten-borders pTypeList"
										value={housingInfo.county}
										onChange={this.setHousingInfoCounty}
										options={countyList.map(county => (
											{
												value: county.code, label: county.value
											}
										))}
									/>
								</FormGroup>
							</Col>
						</Row>

						<Row>
						<Col sm='4'>
								<Label className="walkerandwheelchair-header font-weight-bold mb-5" htmlFor="walkerandwheelchair">
									Do you use:
								</Label>
								<CheckboxGroup value={housingInfo.walkerAndWheelChair} name="walkerandwheelchair" onChange={this.onChangeUseQuestion}>
									<Checkbox 
										label="A walker"
										name="walker"
										id="walkerusage"
										className="label-font no-display"
										groupName="walkerandwheelchair"
										value="A walker"
									/>
									<Checkbox 
										label="A wheelchair"
										name="wheelchair"
										id="wheelchairusage"
										className="label-font no-display"
										groupName="walkerandwheelchair"
										value="A wheelchair"
									/>
								</CheckboxGroup>
							</Col>
						</Row>

						{housingInfo.walkerAndWheelChair && housingInfo.walkerAndWheelChair.includes('A wheelchair') &&
							<>
								<Row>
									<Col>
										<Label className="wheelchairType-header font-weight-bold mb-5" htmlFor="wheelchairTypeRadio">
											Select Type*
										</Label>
										<RadioGroup inline value={housingInfo.wheelchairType} name="wheelchairTypeRadio" onChange={this.onChangeWheelchairType}>
											<Radio className="label-font-round" name="wheelchairTypeRadioManual" label="Manual" value="Manual" />
											<Radio className="label-font-round" name="wheelchairTypeRadioElectric" label="Electric" value="Electric" />
										</RadioGroup>
									</Col>
								</Row>

								<Row>
									<Col sm="4">
										<FormGroup for="widthOfWheelchair" className="label-font">
											<Label for="widthOfWheelchair">
												Width of Chair*
											</Label>
											<SelectField
												name="widthOfWheelchair"
												className="straighten-borders"
												value={housingInfo.wheelchairWidth}
												onChange={this.onChangeWidthOfWheelchair}
												options={this.getSelectOptions(18, 44, (m) => `${m} inches`)}
												isDisabled={housingInfo.wheelchairType === ''}
											/>
										</FormGroup>
									</Col>
								</Row>
							</>
						}

						<Row>
							<Col>

								<FormGroup for="housingModificationsRadio" >
									<Label for="housingModificationsRadio">
										<strong>Do you know if you  will need to request reasonable modifications and/or accommodations once you obtain housing due to a disability?* </strong>
										<i>
											(Example: ADA (The Americans with Disabilities Act) accessible unit)
										</i>
									</Label>
									<RadioGroup inline
										value={housingInfo.modifications}
										name="housingModificationsRadio"
										onClick={this.setHousingModificationsRadio}
										style={{ marginTop: '1rem' }}

									>
										<Radio className="label-font-round" label="Yes" value="Yes" />
										<Radio className="label-font-round" label="No" value="No" />
									</RadioGroup>
									{housingInfo.modifications === 'Yes' && (
										<div>
											<Label className='mb-1' htmlFor='reasonableAccommodationsDetails'>
												<strong>What reasonable accommodations and/or modifications are needed?</strong>
											</Label>
											<Row className='resonable_acc'>
												<Col sm="6">
													<Field
														type="textarea"
														style={{ height: '128px' }}
														value={housingInfo.reasonableAccommodations}
														name="reasonableAccommodationsDetails"
														aria-label='reasonable_accomodation_label'
														onChange={this.setReasonableAccommodationsDetails}
														maxLength={2000}
													/>
												</Col>
											</Row>
											<Row>
												<Col sm="6">
													<Label style={{ display: 'block' }} className="small text-right">2000 Character max</Label>
												</Col>
											</Row>

										</div>

									)}

								</FormGroup>
							</Col>
						</Row>
						<Row>
							<Col className='unitSize'>
								<Label className='label-font' htmlFor='housingProfileUnitSize' />

								<FormGroup for="housingInfoUnitSizeRadio">
									<Label for="housingInfoUnitSizeRadio">
										<strong>What size unit is needed?*</strong>
									</Label>
									<RadioGroup
										value={housingInfo.unitSize}
										name="housingInfoUnitSizeRadio"
										onChange={this.setHousingInfoUnitSizeRadio}
									>
										<Radio className="label-font-round" label="Studio" value="Studio" />
										<Radio className="label-font-round" label="1 bedroom" value="1 bedroom" />
										<Radio className="label-font-round" label="2 bedroom" value="2 bedroom" />
										<Radio className="label-font-round" label="3 bedroom" value="3 bedroom" />
										<Radio className="label-font-round" label="4+ bedroom" value="4+ bedroom" />
									</RadioGroup>


								</FormGroup>
							</Col>
						</Row>

						<Row>
							<Col>
								<Label className="otherHousehold-header font-weight-bold mb-5" htmlFor="otherHouseHoldPersonRadio">
									Other than the head of the household, are there any other adults (age 18+) in your household?*
								</Label>
								<RadioGroup inline value={housingInfo.otherHouseHoldPerson} name="otherHouseHoldPersonRadio" onChange={this.onChangeOtherHouseHoldPerson}>
									<Radio className="label-font-round" name="otherHouseHoldPersonRadioYes" label="Yes" value="Yes" />
									<Radio className="label-font-round" name="otherHouseHoldPersonRadioNo" label="No" value="No" />
								</RadioGroup>
							</Col>
						</Row>

						<Row>
							<Col sm="4">
								<FormGroup for="peopleLiving" className="label-font">
									<Row>
										<Col>
											<Label for="peopleLiving" className="font-weight-bold mb-3">
												How many people will be living with you?*
											</Label>
											<Label for="peopleLiving" className='selectLivingNum'>
												Select Number
											</Label>
										</Col>
									</Row>
									<Row>
										<Col sm="9">
											<SelectField
												name="peopleLiving"
												className="straighten-borders"
												value={housingInfo.peopleLiving}
												onChange={this.onChangePeopleLiving}
												options={this.getSelectOptions(0, 10, m => m)}
											/>
										</Col>
									</Row>
								</FormGroup>
							</Col>
						</Row>

						{housingInfo.peopleLiving > 0 &&
							<>
								<Row>
									<Col>
										<Label className="font-weight-bold mb-3">
											Please provide name and contact information for each person(s) living with you*<br />
										</Label>
									</Col>
								</Row>
								<Row>
									<Col>
										<Label className='selectLivingNum mb-3'>
											Note: Individuals age 18+ may be subjected to background check
										</Label>
									</Col>
								</Row>
								{this.getPeopleInformation()}
								{peopleLivingDetails.length < 10 &&
									<Row>
										<Button color='link' onClick={() => this.onChangePeopleLiving(peopleLivingDetails.length + 1)}>{`+Add Person ${housingInfo.peopleLiving + 1}`}</Button>
									</Row>
								}
							</>
						}

						<Row>
							<Col>
								<FormGroup>
									<Row>
										<Col>
											<Label className='font-weight-bold mb-3' htmlFor='otherPreferences'>
												Do you have any other preferences, needs, and/or limitations that will help with housing identification?
											</Label>
										</Col>
									</Row>
									<Row className='resonable_acc'>
										<Col sm="6">
											<Field
												type="textarea"
												value={housingInfo.otherPreferences}
												name="otherPreferences"
												aria-label='preference_label'
												onChange={this.onChangeOtherPreferences}
												maxLength={2000}
											/>
										</Col>
									</Row>
									<Row>
										<Col sm="6">
											<Label style={{ display: 'block' }} className="small text-right">2000 Character max</Label>
										</Col>
									</Row>
								</FormGroup>
							</Col>
						</Row>

						<Button type="button" color={"primary"} className={'btn btn-primary straighten-borders buttonBack'} onClick={this.goBack}>
							Back
						</Button>
						<Button type="submit" color={"primary"} className={'btn btn-primary awardeeNextBtn mb-50'}>
							Next
						</Button>
					</Form>
				</div>
				<div className='pb-spacer9hRem' />
			</>
		);
	}
}

HousingProfile.propTypes = {
	history: PropTypes.object,
	location: PropTypes.shape({
		state: PropTypes.shape({
			fromReviewAndSubmitPage: PropTypes.bool
		})
	})
}